export const getOrdinalSuffix = (n: number): string => {
  const remainderTen = n % 10;
  const remainderHundred = n % 100;

  if (remainderHundred >= 11 && remainderHundred <= 13) {
    return "th";
  }

  switch (remainderTen) {
    case 1:
      return "st";
    case 2:
      return "nd";
    case 3:
      return "rd";
    default:
      return "th";
  }
};
